const MAX_LENGTH = 40;

export function sanitizeFileName(name: string): string {
  const trimmed = name.trim().replace(/\s+/g, '-');
  const safe = trimmed.replace(/[^a-zA-Z0-9._-]+/g, '-');
  const collapsed = safe.replace(/-+/g, '-').replace(/^-|-$/g, '');
  if (!collapsed) {
    return 'agent';
  }
  return collapsed.length > MAX_LENGTH
    ? collapsed.slice(0, MAX_LENGTH)
    : collapsed;
}
